import { $, $$ } from "../query.ts";

window.matchMedia("(prefers-color-scheme: dark)").onchange = (e) => {
    switch (e.matches) {
        case true: // dark
            $("html").classList.add("wa-dark");
            break;
        case false: // light
            $("html").classList.remove("wa-dark");
            break;
    }

    return true;
};

const menu = $("#menu");
const burger = $("#menu-burger");
burger.onmouseup = () => {
    if (burger.getAttribute("open") === null) {
        menu.style.setProperty("left", "0rem");
        burger.setAttribute("open", "");
        burger.querySelector("wa-icon")?.setAttribute("name", "close");
    } else {
        menu.style.setProperty("left", "-30rem");

        burger.removeAttribute("open");
        burger.querySelector("wa-icon")?.setAttribute("name", "bars");
    }
};

$("#login-button", true).onmouseup = () =>
    (window.location.href = "/auth/login");

$("#logout-button", true).onmouseup = () =>
    (window.location.href = "/auth/logout");

$("#logo").onmouseup = () => (window.location.href = "/");

$$("wa-tree-item").forEach((e) => {
    e.style += "cursor: pointer;";

    e.onmouseup = (e: MouseEvent) => {
        if (e.target === null) {
            return;
        }
        const element: HTMLElement = e.target as HTMLElement;

        if (element.hasAttribute("href")) {
            window.location.href = element.getAttribute("href") ?? "/";
        }

        if (element.hasAttribute("expanded")) {
            element.removeAttribute("expanded");
        } else {
            element.setAttribute("expanded", "");
        }
    };
});
